/* eslint-disable import/no-default-export */
import { Tile } from './Tile';
export default Tile;
